var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4346 4.51562H11.75C10.6111 4.51562 9.68457 5.4422 9.68457 6.58105V9.33496C9.68457 9.71542 9.99259 10.0234 10.373 10.0234H23.5V6.58105C23.5 5.4422 22.5734 4.51562 21.4346 4.51562Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30762 9.33496V8.64648H1.37695V1.07324C1.37695 0.692787 1.06893 0.384766 0.688477 0.384766C0.308022 0.384766 0 0.692787 0 1.07324V16.3115C0 16.692 0.308022 17 0.688477 17C1.06893 17 1.37695 16.692 1.37695 16.3115V14.2002H22.123V16.3115C22.123 16.6918 22.4312 17 22.8115 17C23.1918 17 23.5 16.6918 23.5 16.3115V11.4004H10.373C9.2324 11.4004 8.30762 10.4756 8.30762 9.33496Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30762 5.2041C8.30762 6.34475 7.38284 7.26953 6.24219 7.26953C5.10154 7.26953 4.17676 6.34475 4.17676 5.2041C4.17676 4.06345 5.10154 3.13867 6.24219 3.13867C7.38284 3.13867 8.30762 4.06345 8.30762 5.2041Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.78773fdd.svg";
export { ForwardRef as ReactComponent };